import _ from 'underscore';
import { checkbox } from './checkbox';
import { radios } from './radios';
import { select } from './select';
import { text } from './text';
import { textarea } from './textarea';
import { label } from './label';
import { visible } from './visible';
import { collapse } from './collapse';
import { staticControl } from './static';
import { group } from './group';

const specified = {
  checkbox,
  collapse,
  group,
  radios,
  'inline-radios': radios,
  select,
  text,
  textarea,
  static: staticControl,
};

/**
 * specify observable define base on control
 * @param {String} control - control name
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field option generate before
 * @param {Object} viewModel - object with all property observable define
 * @returns {undefined} - no results
 */
export function controlSpecified(control, local, attrs, fieldOption, viewModel) {
  if (fieldOption.hasSubFields !== true) {
    label(local, attrs, fieldOption, viewModel);
    visible(local, attrs, fieldOption, viewModel);
  }

  if (_.isFunction(specified[control])) {
    specified[control](local, attrs, fieldOption, viewModel);
  }
}
